import Plyr from 'plyr';
$('.js-video').each(function() {
	const player = new Plyr(this,{
		controls: ['play-large','progress', 'fullscreen'],
		// Localisation
		i18n: {
			restart: 'Перезапустить',
			rewind: 'Назад на {seektime}с',
			play: 'Воспроизвести',
			pause: 'Пауза',
			fastForward: 'Вперед на {seektime}с',
			seek: 'Искать',
			seekLabel: '{currentTime} из {duration}',
			played: 'Проиграно',
			buffered: 'Буффер',
			currentTime: 'Текущее время',
			duration: 'Длительность',
			volume: 'Громкость',
			mute: 'Отключить звук',
			unmute: 'Включить звук',
			enableCaptions: 'Включить титры',
			disableCaptions: 'Выключить титры',
			enterFullscreen: 'Полноэкранный режим',
			exitFullscreen: 'Выйти из полноэкранного режима',
			frameTitle: 'Сейчас играет {title}',
			captions: 'Титры',
			settings: 'Настройки',
			menuBack: 'В предыдущее меню',
			speed: 'Скорость',
			normal: 'Нормальная',
			quality: 'Качество',
			loop: 'Зациклить',
			start: 'Начало',
			end: 'Конец',
			all: 'Все',
			reset: 'Сбросить',
			disabled: 'Выключено',
			enabled: 'Включено',
			advertisement: 'Реклама',
			qualityBadge: {
				2160: '4K',
				1440: 'HD',
				1080: 'HD',
				720: 'HD',
				576: 'SD',
				480: 'SD',
			}
		},
		iconPrefix: 'icon',
		iconUrl: '/templates/img/sprite.svg'
	});
});
